import request from '@/utils/request'

// 创建订单接口
export function api_createOrder(data){
  return request({
    url: '/publicszoneui.service/OrderService/createOrder',
    method: 'post',
    data
  })
}

// 创建订单后获取支付连接
export function api_getPaymentUrl(data){
  return request({
    url: '/publicszoneui.service/OrderService/awakenPay',
    method: 'post',
    data
  })
}

// 创建订单后获取订单状态
export function api_queryOrderState(params){
  return request({
    url: '/publicszoneui.service/OrderService/queryOrderState',
    method: 'get',
    params: {
      ...params
    }
  })
}
